import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * Creates traversable 1x1x1 brick gameobjects.
 * @param {HYPERCUBEJS.Material} [$material] The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectbrick1x1x1traversable($material = HYPERCUBEJS.DEFAULTS.material()) {

    const brick1x1x1traversable = new HYPERCUBEJS.Node('brick1x1x1traversable');
    const meshbrick1x1x1traversable = new HYPERCUBEJS.MeshBox('meshbrick1x1x1traversable', [1, 1, 1]);

    const gray = 0.8 + 0.2 * Math.random();

    const color = new HYPERCUBEJS.MaterialColor('plop', {

        // 'color': [Math.random(), Math.random(), Math.random()]
        // 'color': [Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5]
        // 'color': [1.0, 1.0, 1.0]
        'color': [gray, gray, gray]
    });

    meshbrick1x1x1traversable.setmaterial(color);

    // meshbrick1x1x1traversable.setmaterial($material);
    brick1x1x1traversable.addmesh(meshbrick1x1x1traversable);

    return brick1x1x1traversable;
}

export {

    gameobjectbrick1x1x1traversable
};

export default gameobjectbrick1x1x1traversable;
